const Layout = () => import(/* webpackChunkName: 'index' */ '../page/layout')
export const adminRouter=[
    {//医院管理
        path: '/hospAdmin',
        component: () => import(/* webpackChunkName: 'home' */ '../page/admin/hospAdmin'),
    },
    {//医生管理
        path: '/docAdmin',
        component: () => import(/* webpackChunkName: 'home' */ '../page/admin/docAdmin'),
    },
    {//统计中心
        path: '/state',
        component: () => import(/* webpackChunkName: 'home' */ '../page/state'),
    },
    {//统计中心医生数据
        path: '/docState',
        component: () => import(/* webpackChunkName: 'home' */ '../page/state/docState'),
    },
    {
        path: '/allCase',
        component: () => import(/* webpackChunkName: 'home' */ '../page/static/allCase'),
    }
]
export const rolloutRouter=[
    {
        path: '/',
        redirect: '/rolloutList',
        component: () => import(/* webpackChunkName: 'home' */ '../page/rollOut/rolloutList'),
    },
    {//申请管理
        path: '/rolloutList',
        name:'rolloutList',
        component: () => import(/* webpackChunkName: 'home' */ '../page/rollOut/rolloutList'),
    },
    {//新建转诊病历
        path: '/rolloutForm',
        component: () => import(/* webpackChunkName: 'home' */ '../page/rollOut/rolloutForm'),
    },
    {//选择医院
        path: '/selectHosp',
        component: () => import(/* webpackChunkName: 'home' */ '../page/rollOut/selectHosp'),
    },
    {//确认订单
        path: '/detminMsg',
        component: () => import(/* webpackChunkName: 'home' */ '../page/rollOut/detminMsg'),
    },
]
export const rollinRouter=[
    {//转入管理
        path: '/rollinList',
        component: () => import(/* webpackChunkName: 'home' */ '../page/rollIn/rollinList'),
    },
    {//转诊病历详情
        path: '/formDetail',
        component: () => import(/* webpackChunkName: 'home' */ '../page/rollIn/formDetail'),
    }
]
export const stateRouter=[
    {
        path:'/allCase',
        component: () => import(/* webpackChunkName: 'home' */ '../page/static/allCase'),
    }
]


// WEBPACK FOOTER //
// ./src/router/routerTable.js